






















import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";

@Component
export default class InputComponent extends Vue {
  @Prop()
  public labelName!: string;
  @Prop()
  public inputId!: string;
  @Prop({
    default: "text"
  })
  public inputType!: string;
  @Prop({
    default: true
  })
  public isPwOpenChecker!: boolean;

  @Prop({
    default: ""
  })
  value!: string;

  @Prop({
    default: ""
  })
  validationMsg?: string;

  isFocus: boolean = false;
  isToggle: boolean = false;

  isPwOpen: boolean = false;
  receiveInputType: string = this.inputType;
  internalValue: string = this.value;

  @Emit()
  change(value: string): string {
    return value;
  }

  @Watch("internalValue")
  onInternalChange(newVal: string) {
    this.change(newVal);
  }

  @Watch("value")
  onExternalChange(newVal: string) {
    this.internalValue = newVal;
  }

  isPassword(): boolean {
    return this.inputType === "password";
  }

  togglePwOpen(): void {
    this.isPwOpen = !this.isPwOpen;
    this.receiveInputType = this.isPwOpen ? "text" : "password";
    this.isToggle = true;
  }

  get togglePasswordImage() {
    return this.isPwOpen
      ? "/images/icons/btn_form_visibility_on.png"
      : "/images/icons/btn_form_visibility_off.png";
  }

  focus() {
    this.isFocus = true;
  }

  blur() {
    if (this.isToggle) {
      const input = this.$refs.input_component as HTMLInputElement;
      input.focus();
      this.isToggle = false;
      return;
    }
    this.isFocus = false;
  }
}
